import { useTranslation } from 'react-i18next';
import { Icon, Typography } from '@/components';
import { OpportunityDetails, OpportunityItemList } from '../../../types';
import { useOpportunityStats } from '@/features/stats/hooks/use-opportunity-stats';
import { IconName } from '@/components/icons/types';

export type OpportunityStatsProps = {
  readonly opportunity: OpportunityDetails | OpportunityItemList;
};

export function OpportunitySellerStats({ opportunity }: OpportunityStatsProps) {
  const { t } = useTranslation(['opportunities']);
  const stats = useOpportunityStats({ id: opportunity.id });

  const visibleStatuses = ['pending', 'accepted', 'rejected'];
  const filteredOffers = opportunity.offers.filter((offer: any) => visibleStatuses.includes(offer?.status?.name));

  const infoStats = [
    {
      icon: 'my-offers' as IconName,
      title: t('Received Offers'),
      value: filteredOffers.length.toString(),
    },
    {
      icon: 'eye-open' as IconName,
      title: t('Opportunity Views'),
      value: stats?.views.toString() ?? '0',
    },
    {
      icon: 'download' as IconName,
      title: t('Downloads'),
      value: stats?.downloads.toString() ?? '0',
    },
  ];

  return (
    <div className="rounded-lg border bg-white p-6 shadow-xs">
      <Typography as="h3" weight="semibold" size="title" className="mb-6 uppercase">
        {t('Deal Summary')}
      </Typography>

      <div className="space-y-6">
        {infoStats.map((stat, index) => (
          <div className="rounded-lg p-3 shadow-md" key={index}>
            <div className="mb-2 flex items-center justify-between">
              <div className="flex w-3/4 items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-green-100">
                  <Icon name={stat.icon} className="h-10 w-10 rounded-full bg-neutral-50 p-2" />
                </div>
                <div className="w-full">
                  <span className="text-base font-medium text-gray-700">{stat.title}</span>
                </div>
              </div>
              <span className="w-1/4 text-right text-3xl font-bold text-gray-800">{stat.value}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
